import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AppUser, EmployeeProfileApi } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { LoaderService } from '../core/loader.service';

@Component({
  selector: 'eos-user',
  templateUrl: './user.component.html',
  styleUrls: []
})
export class UserComponent implements OnInit {

  user: AppUser;
  model;
  constructor(
    private authService: AuthService,
    private employeeApi: EmployeeProfileApi,
    private loader: LoaderService) { }

  ngOnInit() {
    this.getUserDetail();
  }
  getUserDetail() {
    this.user = this.authService.ActiveUser;
  }
}
